var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { CircularProgress } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import colors from '../../themes/colors';
var TIMEOUT_MS = 100;
var transitionIn = keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  0% { opacity: 0; }\n  100% { opacity: 1; }\n"], ["\n  0% { opacity: 0; }\n  100% { opacity: 1; }\n"])));
var transitionOut = keyframes(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  0% { opacity: 1; }\n  100% { opacity: 0; }\n"], ["\n  0% { opacity: 1; }\n  100% { opacity: 0; }\n"])));
var SpinnerContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  background-color: rgba(248, 249, 250, 0.5);\n  display: grid;\n  place-items: center;\n  z-index: 10000;\n  animation: ", " ", "ms ease-in-out forwards;\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  background-color: rgba(248, 249, 250, 0.5);\n  display: grid;\n  place-items: center;\n  z-index: 10000;\n  animation: ", " ", "ms ease-in-out forwards;\n"])), function (_a) {
    var show = _a.show;
    return (show ? transitionIn : transitionOut);
}, function (_a) {
    var timeout = _a.timeout;
    return timeout;
});
var Spinner = function (_a) {
    var variant = _a.variant, _b = _a.loading, loading = _b === void 0 ? true : _b, _c = _a.timeout, timeout = _c === void 0 ? TIMEOUT_MS : _c;
    var timeoutRef = useRef(-1);
    var color = variant === 'primary' ? colors.neutral100 : colors.neutral30;
    var _d = useState(loading), show = _d[0], setShow = _d[1];
    useEffect(function () {
        clearTimeout(timeoutRef.current);
        if (!loading) {
            timeoutRef.current = window.setTimeout(function () {
                setShow(false);
            }, TIMEOUT_MS);
        }
        else {
            setShow(true);
        }
    }, [loading]);
    if (!show)
        return null;
    return (_jsx(SpinnerContainer, __assign({ timeout: timeout, show: loading, "data-testid": "loading-spinner" }, { children: _jsx(CircularProgress, { sx: { color: color }, size: 60 }) })));
};
Spinner.defaultProps = {
    variant: 'primary',
    loading: false,
    timeout: TIMEOUT_MS
};
export default Spinner;
var templateObject_1, templateObject_2, templateObject_3;
